import request from '@/utils/request'

/**
 * Профиль пользователя
 * @returns {Promise<Profile>}
 */
export function getMyself() {
  return request({
    url: `/api/profile/me/`,
    method: 'get',
  })
}
